import React, { useState, useContext, useEffect, useRef } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import CalenderIcon from "../../images/calender.svg";
import TimeIcon from "../../images/time.svg";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FaClock, FaAlignLeft } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import SuccessIcon from "../../images/success.svg";
import NoDataFoundIcon from "../../images/NoAppointment.gif";
import Image from "react-bootstrap/Image";
import TherapistSidebar from "../../inc/TherapistSidebar";
import UserAvatar from "../../common/UserAvatar";
import Form from "react-bootstrap/Form";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import ConstConfig from "../../../utility/configs/constConfig";
import Functions from "../../../utility/services/Functions";
import { toast } from "react-toastify";
import ImageConfig from "../../../utility/configs/imageConfig";
import ReactLoader from "react-js-loader";
import { Tooltip } from "react-tooltip";
import moment from "moment";
import { FaTimesCircle } from "react-icons/fa";
import { trackScreenView, trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const rejectReasons = [
  {
    title: "Didn’t fit in my schedule",
    checked: false,
  },
  {
    title: "Something important came up",
    checked: false,
  },
  {
    title: "Booked appointment by mistake",
    checked: false,
  },
  {
    title: "Selected wrong time slot",
    checked: false,
  },
];

/*eslint eqeqeq: "off"*/
const Dashboard = () => {
  // LOGICAL VARIABLES

  const {
    setLoading,
    user,
    activeTab,
    setActiveTab,
    authUserRole,
    loading,
    refreshAppointmentType,
    receive_call_audio,
    showOldLicenseModal,
    setShowOldLicenseModal,
  } = useContext(AuthContext);
  const [loadingList, setLoadingList] = useState(false);
  const [openedRequest, setOpenedRequest] = useState({});
  const {
    get_therapist_upcoming_appointment_list,
    get_therapist_past_appointment_list,
    get_therapist_request_appointment_list,
    therapist_approve_request,
    therapist_reject_request,
    therapist_cancel_request,
    get_therapist_booked_dates,
    therapist_reschedule_booking,
    patient_reschedule_booking,
    get_booking_timing,
    get_patient_upcoming_appointment_list,
    get_booking_timing_for_patient,
    patient_cancel_booking_request,
    get_patient_past_appointment_list,
    cancel_booking_List_for_patient,
    get_therapist_full_details_for_patient,
    update_timezone_us,
  } = ApiService();
  const {
    consoleService,
    formet_date,
    formet_time,
    scheduledTimeForTherapist,
    get_upcoming_timp_diff,
    calculateAge,
    set_user_details,
    get_day,
    combine_time_to_date,
    scheduledTimeSlotForTherapist,
    checkActiveTimeSlots,
    get_gender,
    isLastPage,
    set_patient_user_details,
    simpleArrayString,
    enctyptDataFun,
    decryptData,
  } = Functions();

  const [isUpcomingAppointmentFetched, setIsUPcomingAppointmentFetched] =
    useState(false);
  const [isRequestAppointmentFetched, setIsRequestAppointmentFetched] =
    useState(false);

  const [isPastAppointmentFetched, setIsPastAppointmentFetched] =
    useState(false);
  const [isCancelledAppointmentFetched, setIsCancelledAppointmentFetched] =
    useState(false);

  const [rescheduledDateTime, setRescheduledDatetime] = useState("");
  const [rescheduledSlotsMin, setRescheduledSlotsMin] = useState("");
  const [rescheduledBookinId, setRescheduledBookingId] = useState("");
  const [loadmoreLoading, setLoadmoreLoading] = useState(false);
  const [rescheduleRequestEventName, setRescheduledRequestEventName] =
    useState("");
  const [totalRequests, setTotalRequests] = useState("");
  const [totalCancelledAppointments, setTotalCancelledAppointments] =
    useState("");
  const [requestListPageNo, setRequestListPageNo] = useState("");
  const [cancelledListPageNo, setCancelledListPageNo] = useState("");
  const [totalUpcomingAppoiments, setTotalUpcomingAppointments] = useState("");
  const [upcomingListPageNo, setUPcomingListPageNo] = useState("");
  const [totalPastAppointments, setTotalPastAppointments] = useState("");
  const [pastListPageNo, setPastListPageNo] = useState("");
  const [filterHideShow, setfilterHideShow] = useState(false);

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow1, setModalShow1] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);
  const [modalShow3, setModalShow3] = React.useState(false);
  const [modalShow4, setModalShow4] = React.useState(false);
  const [modalShow5, setModalShow5] = React.useState(false);
  const [modalShow6, setModalShow6] = React.useState(false);
  const [modalShow7, setModalShow7] = React.useState(false);
  const [modalShow8, setModalShow8] = React.useState(false);

  const [selectedIndexForMore, setSelectedIndexForMore] = useState(null);

  const navigate = useNavigate();

  const IsTherapist = authUserRole == "Therapist";
  // DATA VARIABLES

  const [upcomingAppointmentList, setUpcomingAppointmentList] = useState([]);
  const [requestList, setRequestAppointmentList] = useState([]);
  const [pastAppointmentList, setPastAppointmentList] = useState([]);
  const [bookedDates, setBookedDates] = useState([]);
  const [cancelledAppointmentsList, setCancelledAppointmentsList] = useState(
    []
  );

  // USE EFFECTS

  useEffect(() => {
    trackScreenView("home_screen", {
      screen_name: "Dashboard",
      user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
      user_role: authUserRole,
    });
    initial_function();
  }, []);

  useEffect(() => {
    check_show_licenses_warning();
  }, [user]);

  useEffect(() => {
    const EventType = refreshAppointmentType.type;
    if (EventType == "new_booking") {
      if (activeTab == "requests") {
        fetch_lists(activeTab, false);
      }
    } else if (
      EventType == "req_approved" ||
      EventType == "req_rescheduled" ||
      EventType == "appointment_start"
    ) {
      if (activeTab == "upcoming") {
        fetch_lists(activeTab, false);
      }
    } else if (EventType == "req_cancelled" || EventType == "req_rejected") {
      if (activeTab == "upcoming" || activeTab == "cancelled") {
        fetch_lists(activeTab, false);
      }
    }
  }, [refreshAppointmentType]);

  // FUNCTIONS

  const handleClose = () => setModalShow2(false);
  const handleClose3 = () => setModalShow3(false);
  const handleClose4 = () => setModalShow4(false);
  const handleClose5 = () => setModalShow5(false);
  const handleClose6 = () => setModalShow6(false);
  const handleClose7 = () => setModalShow7(false);
  const handleClose8 = () => setModalShow8(false);

  async function initial_function() {
    try {
      setLoading(true);
      await Promise.all([fetch_initial_details()]);
      setLoading(false);
    } catch (err) {
      consoleService("error in initial_function  = ", err);
    }
  }

  async function fetch_initial_details() {
    try {
      IsTherapist ? await set_user_details() : await set_patient_user_details();
      await fetch_lists(activeTab);
      setIsUPcomingAppointmentFetched(true);
      return;
    } catch (err) {
      consoleService("Error in fetch_initial_details", err);
    }
  }

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const handleClose11 = () => setModalShow(false);

  const handleClose1 = () => {
    setModalShow(false);
    setModalShow1(false);
  };

  const show_modal_fun = (setMethod) => {
    const modal_arr = [
      setModalShow,
      setModalShow1,
      setModalShow2,
      setModalShow3,
      setModalShow4,
      setModalShow5,
      setModalShow6,
      setModalShow7,
      setModalShow8,
    ];

    modal_arr.forEach((setElement) => {
      if (setElement != setMethod) {
        setElement(false);
      } else {
        setElement(true);
      }
    });
  };

  async function check_show_licenses_warning() {
    const userDetails = IsTherapist
      ? user.details
      : openedRequest.therapist_details;

    if (userDetails && IsTherapist && userDetails?.state_id != null) {
      const wait_for_7_seconds = new Promise((resolve) =>
        setTimeout(resolve, 1000)
      );
      await wait_for_7_seconds;
      let OldLicenseWarningSeenData = null;
      try {
        const decryptedData = decryptData("E_C_O_L_W_S");
        OldLicenseWarningSeenData = decryptedData
          ? JSON.parse(decryptedData)
          : null;
      } catch (error) {
        console.error("Error parsing license warning data:", error);
      }

      if (!OldLicenseWarningSeenData) {
        setShowOldLicenseModal(true); // Show modal
      } else {
        const warningSeenStatus = OldLicenseWarningSeenData.warning_seen_status;
        if (!warningSeenStatus) {
          setShowOldLicenseModal(true); // Show modal
        } else {
          // Do nothing
        }
      }
      localStorage.setItem(
        "E_C_O_L_W_S",
        enctyptDataFun({ warning_seen_status: true })
      );
    }
  }

  async function fetch_lists(tabName, loading) {
    const Loader = loading != undefined ? loading : true;
    setLoadingList(Loader);
    try {
      if (tabName == "upcoming") {
        const upcoming_appointment_res = IsTherapist
          ? await get_therapist_upcoming_appointment_list(1)
          : await get_patient_upcoming_appointment_list(1);
        if (upcoming_appointment_res.status === 1) {
          setUpcomingAppointmentList([
            ...upcoming_appointment_res.data.pending_bookings,
          ]);
          setTotalUpcomingAppointments(upcoming_appointment_res.data.total);
          setUPcomingListPageNo(1);
          setIsUPcomingAppointmentFetched(true);
          setLoadingList(false);
        }
      } else if (tabName == "past") {
        const past_appointment_res = IsTherapist
          ? await get_therapist_past_appointment_list(1)
          : await get_patient_past_appointment_list(1);
        if (past_appointment_res.status === 1) {
          setPastAppointmentList([...past_appointment_res.data]);
          setTotalPastAppointments(past_appointment_res.ext.total);
          setPastListPageNo(1);
          setIsPastAppointmentFetched(true);
          setLoadingList(false);
        }
      } else if (tabName == "requests") {
        const requests_appointment_res =
          await get_therapist_request_appointment_list(1);
        if (requests_appointment_res.status === 1) {
          setRequestAppointmentList([
            ...requests_appointment_res.data.requests,
          ]);
          setTotalRequests(requests_appointment_res.data.total);
          setIsRequestAppointmentFetched(true);
          setRequestListPageNo(1);
          setLoadingList(false);
        }
      } else if (tabName == "cancelled") {
        const cancelled_appointment_res = await cancel_booking_List_for_patient(
          1
        );
        if (cancelled_appointment_res.status === 1) {
          setCancelledAppointmentsList([...cancelled_appointment_res.data]);
          setTotalCancelledAppointments(cancelled_appointment_res.ext.total);

          setIsCancelledAppointmentFetched(true);
          setCancelledListPageNo(1);
          setLoadingList(false);
        }
      }
    } catch (err) {
      setLoadingList(false);
      consoleService("Error in fetch_lists api", err);
    }
  }

  const approve_request = async (booking_id) => {
    handleClose5();
    setLoading(true);
    try {
      trackEvent("confirm_booking_cta", {
        event_type: "button_click",
        button_name: "Accept",
        screen_name: "Therapist Dashboard",
        user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
        user_role: authUserRole,
        patient_name: openedRequest.patient_details ? `${openedRequest.patient_details.first_name} ${openedRequest.patient_details.last_name || ""}`.trim() : "",
      });
      const res = await therapist_approve_request({
        booking_id,
      });

      if (res.status === 1) {
        trackEvent("payment_done", {
          event_type: "payment_success",
          screen_name: "Therapist Dashboard",
          user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
          user_role: authUserRole,
          patient_name: openedRequest.patient_details ? `${openedRequest.patient_details.first_name} ${openedRequest.patient_details.last_name || ""}`.trim() : "",
        });
        const index = requestList.findIndex((item) => {
          return item.booking_id == booking_id;
        });

        const newList = requestList;

        newList.splice(index, 1);
        setRequestAppointmentList([...newList]);
        setLoading(false);
        show_modal_fun(setModalShow6);
      } else if (res.status === 2) {
        toast.error(
          <div style={{ textAlign: "center", fontSize: "14px" }}>
            <span>{res.message} </span>
            <span
              onClick={() => navigate("/therapistbankdetails")}
              style={{
                color: "#1d7e7c",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "bold",
                display: "inline-block",
                marginLeft: "5px",
              }}
            >
              Click here
            </span>
          </div>,
          {
            position: "top-center",
            hideProgressBar: true,
          }
        );

        setLoading(false);
      } else {
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in approve_request api", err);
    }
  };

  const reject_request = async (booking_id) => {
    handleClose7();
    setLoading(true);
    try {
      const res = await therapist_reject_request({
        booking_id,
      });

      if (res.status === 1) {
        const index = requestList.findIndex((item) => {
          return item.booking_id == booking_id;
        });

        const newList = requestList;

        newList.splice(index, 1);
        setRequestAppointmentList([...newList]);
        setOpenedRequest({});
        setLoading(false);
      } else {
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in approve_request api", err);
    }
  };

  function get_page_number(list) {
    const total_items = list.length;
    const limit = 10;

    const divided_val = total_items / limit;

    let pageNumber = Math.ceil(divided_val);

    const isDecimal = divided_val % 1 !== 0;

    if (!isDecimal) {
      pageNumber += 1;
    }

    return pageNumber;
  }

  const loadmore_requests = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(requestListPageNo) + 1;
      try {
        const requests_appointment_res =
          await get_therapist_request_appointment_list(pageNo);
        if (requests_appointment_res.status === 1) {
          setRequestAppointmentList([
            ...requestList,
            ...requests_appointment_res.data.requests,
          ]);
          setTotalRequests(requests_appointment_res.data.total);
          setRequestListPageNo(pageNo);
          setLoadmoreLoading(false);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in loadmore requests api", err);
      }
    }
  };

  const loadmore_upcoming_appointments = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(upcomingListPageNo) + 1;
      try {
        const upcoming_appointment_res = IsTherapist
          ? await get_therapist_upcoming_appointment_list(pageNo)
          : await get_patient_upcoming_appointment_list(pageNo);
        if (upcoming_appointment_res.status === 1) {
          setUpcomingAppointmentList([
            ...upcomingAppointmentList,
            ...upcoming_appointment_res.data.pending_bookings,
          ]);
          setTotalUpcomingAppointments(upcoming_appointment_res.data.total);
          setUPcomingListPageNo(pageNo);
          setLoadmoreLoading(false);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in loadmore upcoming list api", err);
      }
    }
  };

  const loadmore_cancelled_appointments = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(cancelledListPageNo) + 1;
      try {
        const cancelled_appointment_res = await cancel_booking_List_for_patient(
          pageNo
        );
        if (cancelled_appointment_res.status === 1) {
          setCancelledAppointmentsList([
            ...cancelledAppointmentsList,
            ...cancelled_appointment_res.data,
          ]);

          setTotalCancelledAppointments(cancelled_appointment_res.ext.total);
          setCancelledListPageNo(pageNo);
          setLoadmoreLoading(false);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService(
          "Error in loadmore loadmore_cancelled_appointments api",
          err
        );
      }
    }
  };

  const loadmore_past_appointments = async () => {
    if (!loadmoreLoading) {
      setLoadmoreLoading(true);
      const pageNo = Number(pastListPageNo) + 1;
      try {
        const past_appointment_res = IsTherapist
          ? await get_therapist_past_appointment_list(pageNo)
          : await get_patient_past_appointment_list(pageNo);

        if (past_appointment_res.status === 1) {
          setPastAppointmentList([
            ...pastAppointmentList,
            ...past_appointment_res.data,
          ]);
          setTotalPastAppointments(past_appointment_res.ext.total);
          setPastListPageNo(pageNo);
          setLoadmoreLoading(false);
        }
      } catch (err) {
        setLoadmoreLoading(false);
        consoleService("Error in loadmore upcoming list api", err);
      }
    }
  };

  const cancel_booking_fun = async (e, selectedRejectReasons, customReason) => {
    e.preventDefault();
    if (selectedRejectReasons.length || customReason) {
      if (customReason) {
        selectedRejectReasons.push(customReason);
      }

      handleClose8();
      setLoading(true);
      try {
        const data = {
          booking_id: openedRequest.booking_id,
          reasons: selectedRejectReasons,
        };
        const res = IsTherapist
          ? await therapist_cancel_request(data)
          : await patient_cancel_booking_request(data);

        if (res.status === 1) {
          await fetch_lists("upcoming");
          show_modal_fun(setModalShow4);

          setLoading(false);
        } else {
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
        consoleService("Error in cancel_booking_fun api", err);
      }
    }
  };

  const fetch_booked_dates = async (e, booking_id, slot_minutes, eventName) => {
    try {
      e.preventDefault();
      const res = await get_therapist_booked_dates(slot_minutes);
      const booked_dates = res.data.booked_dates.map((item) =>
        formet_date(item)
      );
      // setBookedDates([...booked_dates]);
      setRescheduledBookingId(booking_id);
      setRescheduledSlotsMin(slot_minutes);
      setRescheduledRequestEventName(eventName);
      setModalShow(true);
    } catch (err) {
      consoleService("erro in fetch_booked_dates fun = ", err);
    }
  };

  const reschedule_booking_fun = async (e) => {
    e.preventDefault();
    handleClose1();
    setLoading(true);
    try {
      const data = {
        booking_id: rescheduledBookinId,
        date: rescheduledDateTime.toUTCString(),
        time: rescheduledDateTime.toUTCString(),
        slot_minutes: rescheduledSlotsMin,
      };
      const res = IsTherapist
        ? await therapist_reschedule_booking(data)
        : await patient_reschedule_booking(data);

      if (res.status === 1) {
        await fetch_lists(rescheduleRequestEventName);
        show_modal_fun(setModalShow2);
        setLoading(false);
      } else {
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in reschedule_booking_fun api", err);
    }
  };

  function clearRescheduledVariables() {
    setRescheduledBookingId("");
    setRescheduledDatetime("");
    setRescheduledSlotsMin("");
    setRescheduledRequestEventName("");
  }

  function isTimeDisabled(item) {
    return !checkActiveTimeSlots(item.time, item.end_time);
  }

  //////////////////////////////////////////////// NESTED COMPONENTS ////////////////////////////////////

  function RescheduleAppointment(props) {
    const date = new Date();
    const maxDate = new Date().setDate(new Date().getDate() + 15);
    const userDetails = IsTherapist
      ? user.details
      : openedRequest.therapist_details;
    const pricingArray = IsTherapist
      ? userDetails.pricing
      : openedRequest.pricing;
    const initialSlot = pricingArray.find((item) => item.checked == true);
    const availabilityArr = userDetails.availability;
    const [dateValue, onChange] = useState(new Date());
    const [timeValue, setTimeValue] = useState("");
    const [slotValue, setSlotValue] = useState(
      rescheduledSlotsMin ? rescheduledSlotsMin : initialSlot.time_in_min
    );
    const [timeSlots, setTimeSlots] = useState([]);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const is_any_slot_available = timeSlots.some(
      (item) => new Date(item.slot) > new Date()
    );

    useEffect(() => {
      set_available_time_slots(
        new Date(),
        rescheduledSlotsMin ? rescheduledSlotsMin : initialSlot.time_in_min
      );
    }, []);

    const disabled_dates = ({ _, date }) => {
      const userActiveDays = [];
      availabilityArr.forEach((item) => {
        if (item.checked) {
          userActiveDays.push(item.day);
        }
      });
      const day = get_day(date);

      const isFound = userActiveDays.some((item) => item == day);
      if (!isFound) {
        // return true;
        return false;
      } else {
        const isFoundBooked = bookedDates.some(
          (item) => item == formet_date(day)
        );

        // if (isFoundBooked) {
        //   return true;
        // } else {
        //   return false;
        // }\
        if (isFoundBooked) {
          return false;
        } else {
          return false;
        }
      }
    };

    async function set_available_time_slots(date, slot) {
      setLoadingSlots(true);
      try {
        const filter_date = moment(date).format("YYYY-MM-DD");
        const res = IsTherapist
          ? await get_booking_timing(filter_date, slot)
          : await get_booking_timing_for_patient(
              userDetails._id,
              filter_date,
              slot
            );
        if (res.status === 1) {
          const data = res.data;
          const allslots = data?.all_slots || [];
          const emptySlots =
            data?.fetchedRes?.booked_time_stamps?.length > 0
              ? data?.fetchedRes?.empty_time_stamps || []
              : allslots;

          const slots = [];
          allslots.forEach((item) => {
            const isEmpty = emptySlots.some(
              (emptySlot) => formet_time(emptySlot) == formet_time(item)
            );
            if (isEmpty) {
              const isToday =
                formet_date(new Date()) == formet_date(new Date(date));
              if (isToday) {
                const todayTime = Date.now();
                const combineTime = combine_time_to_date(new Date(), item);
                const stampTime = new Date(combineTime).getTime();
                if (todayTime < stampTime) {
                  slots.push({ slot: item, booked: false });
                } else {
                  slots.push({ slot: item, booked: true });
                }
              } else {
                slots.push({ slot: item, booked: false });
              }
            } else {
              slots.push({ slot: item, booked: true });
            }
          });

          setTimeSlots([...slots]);
          onChange(date);
          setTimeValue("");
          setLoadingSlots(false);
          return;
        } else {
          setLoadingSlots(false);
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          return;
        }
      } catch (err) {
        consoleService("error in set_available_time_slots fun = ", err);
        setLoadingSlots(false);

        return;
      }
    }

    const setSlotValueFun = async (time_in_min) => {
      await set_available_time_slots(dateValue, time_in_min);
      setSlotValue(time_in_min);
    };

    const confirmRescheduleFun = (e) => {
      e.preventDefault();
      if (timeValue) {
        setRescheduledDatetime(combine_time_to_date(dateValue, timeValue));
        show_modal_fun(setModalShow1);
        setTimeValue("");
      } else {
        toast("Please select a appointment time first", {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    };

    return (
      <Modal
        {...props}
        size="md"
        className="modalregs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="text-left">
          <section className="packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Package</h2>
                  <ul>
                    {pricingArray.map((item, index) => {
                      if (item.checked && openedRequest.pricing_id == item.id) {
                        const time_in_min = item.time_in_min;
                        return (
                          <li
                            className={slotValue == time_in_min ? "active" : ""}
                            key={index}
                          >
                            <div
                              className="package_box"
                              as="button"
                              onClick={() => {
                                setSlotValueFun(time_in_min);
                              }}
                            >
                              <h3>
                                <FaClock />{" "}
                                {time_in_min == 30 ? "30 min" : "1 hr"}
                              </h3>
                              <h3 className="mb-0">$ {item.price}</h3>
                            </div>
                          </li>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className="pb-4 pt-2 packagebox packagebox_book">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2>Select Date</h2>
                  <Calendar
                    style={{ width: "100%" }}
                    onChange={(date) => {
                      set_available_time_slots(date, slotValue);
                    }}
                    value={dateValue}
                    minDate={date}
                    // maxDate={new Date(maxDate)}
                    tileDisabled={disabled_dates}
                    tileClassName="calendar_tiles"
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="packagebox slotBox">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  {!timeSlots && timeSlots.length > 0 && (
                    <h2>Choose Time Slot</h2>
                  )}
                  {loadingSlots ? (
                    <ReactLoader
                      type="bubble-loop"
                      bgColor={"#1D7E7C"}
                      size={50}
                    />
                  ) : (
                    <ul>
                      {timeSlots.length > 0 && is_any_slot_available ? (
                        timeSlots.map((item, index) => {
                          return (
                            <>
                              {new Date(item.slot) > new Date() && (
                                <li key={index}>
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();

                                      !item.booked && setTimeValue(item.slot);
                                    }}
                                    className={`timebox ${
                                      item.booked
                                        ? "grey"
                                        : timeValue == item.slot
                                        ? "selected"
                                        : "active"
                                    }`}
                                  >
                                    {formet_time(new Date(item.slot))}
                                  </Link>
                                </li>
                              )}
                            </>
                          );
                        })
                      ) : (
                        <span>
                          {IsTherapist
                            ? "You are not available for this date"
                            : "Therapist is not available for this date"}
                        </span>
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer
          className="modalCustomFooter"
          style={{ flexWrap: "nowrap" }}
        >
          <Button
            style={{ width: "48%" }}
            as={Link}
            onClick={(e) => {
              confirmRescheduleFun(e);
            }}
          >
            Reschedule
          </Button>
          <Button
            style={{ width: "48%" }}
            onClick={() => {
              handleClose11();
              clearRescheduledVariables();
            }}
            as={Link}
            variant="outline-primary"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function RescheduleConfirmation(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>Reschedule</h4>
          <p className="mb-1">Are you sure to reschedule your appointment to</p>
          <p style={{ color: "#1D7E7C" }}>
            <strong>
              {formet_date(rescheduledDateTime)} |{" "}
              {formet_time(rescheduledDateTime)}
            </strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={() => {
              handleClose1();
            }}
          >
            No
          </Button>
          <Button as={Link} onClick={(e) => reschedule_booking_fun(e)}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function RescheduleConfirmed(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" className="mb-2" />
          <h4>Confirmed</h4>
          <p className="mb-1">Your appointment has been rescheduled</p>
          <p style={{ color: "#1D7E7C" }}>
            <strong>
              {" "}
              {formet_date(rescheduledDateTime)} |{" "}
              {formet_time(rescheduledDateTime)}
            </strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as={Link}
            onClick={() => {
              handleClose();
              clearRescheduledVariables();
            }}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function CancelAppointment(props) {
    const userDetails = IsTherapist
      ? openedRequest.patient_details
      : openedRequest.therapist_details;
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>Are you Sure?</h4>
          <p className="mb-1">Do you want to cancel your appointment</p>
          <hr />
          <p style={{ color: "#1D7E7C" }}>
            <strong>{`${userDetails?.first_name || ""} ${
              userDetails?.last_name || ""
            }`}</strong>
          </p>
          <p>
            {formet_date(openedRequest.time)} |{" "}
            {formet_time(openedRequest.time)} {openedRequest.speciality}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button as={Link} onClick={handleClose3}>
            No
          </Button>
          <Button as={Link} onClick={() => show_modal_fun(setModalShow8)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function CancelledConfirmed(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess modalBtn"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" className="mb-2" />
          <h4>Cancelled</h4>
          <p className="mb-2">Your appointment has been cancelled</p>
          <p style={{ color: "#1D7E7C" }}>
            <strong>
              {formet_date(openedRequest.time)} |{" "}
              {formet_time(openedRequest.time)}
            </strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button as={Link} onClick={handleClose4}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function AcceptRequest(props) {
    const { patient_details } = openedRequest;

    return (
      <>
        {patient_details != undefined && (
          <Modal
            {...props}
            size="sm"
            className="modalSuccess modalBtn"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <h4>Accept request</h4>
              <p className="mb-1">
                Do you want to accept this appointment request ?
              </p>
              <hr />
              <p style={{ color: "#1D7E7C" }}>
                <strong>
                  {`${patient_details.first_name} ${patient_details.last_name}`}{" "}
                  | {calculateAge(patient_details.dob)}{" "}
                  {get_gender(patient_details.gender)}
                </strong>
              </p>
              <p>
                {openedRequest.speciality.map((item, index) => {
                  return simpleArrayString(
                    item,
                    index,
                    openedRequest.speciality
                  );
                })}
                <br />
                {formet_date(openedRequest.time)} |{" "}
                {formet_time(openedRequest.time)}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button as={Link} onClick={handleClose5}>
                No
              </Button>
              <Button
                as={Link}
                onClick={() => approve_request(openedRequest.booking_id)}
              >
                Continue
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }

  function Reject_Request(props) {
    const { patient_details } = openedRequest;

    return (
      <>
        {patient_details != undefined && (
          <Modal
            {...props}
            size="sm"
            className="modalSuccess modalBtn"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <h4>Reject request</h4>
              <p className="mb-1">
                Are you sure to reject this appointment request?
              </p>
              <hr />
              <p style={{ color: "#1D7E7C" }}>
                <strong>
                  {`${patient_details.first_name} ${patient_details.last_name}`}{" "}
                  | {calculateAge(patient_details.dob)}{" "}
                  {get_gender(patient_details.gender)}
                </strong>
              </p>
              <p>
                {openedRequest.speciality} <br />
                {formet_date(openedRequest.time)} |{" "}
                {formet_time(openedRequest.time)}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button as={Link} onClick={handleClose7}>
                No
              </Button>
              <Button
                as={Link}
                onClick={() => reject_request(openedRequest.booking_id)}
              >
                Continue
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }

  function AcceptConfirmed(props) {
    return (
      <>
        {openedRequest && (
          <Modal
            {...props}
            size="sm"
            className="modalSuccess modalBtn"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <Image src={SuccessIcon} alt="" className="mb-2" />
              <h4>Accepted</h4>
              <p className="mb-1">Appointment has been scheduled</p>
              <p style={{ color: "#1D7E7C" }}>
                <strong>
                  {formet_date(openedRequest.time)} |{" "}
                  {formet_time(openedRequest.time)}
                </strong>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button as={Link} onClick={handleClose6}>
                Done
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }

  function ReasonOfCancellation(props) {
    const [reasonsForReject, setReasonsForReject] = useState([
      ...rejectReasons,
    ]);
    const [other, setOther] = useState(false);

    const [selectedRejectReasons, setSelectedRejectReasons] = useState([]);
    const [customReason, setCustomReason] = useState("");

    const addRejectReasons = (e, title) => {
      const value = e.target.value;
      const toSubmitValue = !JSON.parse(value);
      const oldReasons = selectedRejectReasons;
      const oldReasonsForReject = reasonsForReject;
      const reasonsIndex = oldReasonsForReject.findIndex(
        (item) => item.title == title
      );

      if (toSubmitValue) {
        oldReasons.push(title);
      } else {
        const index = oldReasons.findIndex((item) => item == title);
        oldReasons.splice(index, 1);
      }
      setSelectedRejectReasons([...oldReasons]);
      oldReasonsForReject[reasonsIndex].checked = toSubmitValue;
      setReasonsForReject([...oldReasonsForReject]);
    };

    return (
      <Modal
        {...props}
        size="md"
        className="modalSuccess modalBtn modalBtnCancel"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4>Why are you cancelling the appointment?</h4>
          {reasonsForReject.map((item, index) => {
            return (
              <Form.Group className="mb-4" key={index}>
                {["checkbox"].map((type) => (
                  <div key={`default-${type}`} className="mb-3 termBox">
                    <Form.Check
                      type={type}
                      id={index + 1}
                      checked={reasonsForReject[index].checked}
                      label={<span>{item.title}</span>}
                      value={reasonsForReject[index].checked}
                      onChange={(e) => {
                        addRejectReasons(e, item.title);
                      }}
                    />
                  </div>
                ))}
              </Form.Group>
            );
          })}
          <Form.Group className="mb-4">
            <div key={`default- checkbox`} className="mb-3 termBox">
              <Form.Check // prettier-ignore
                type={"checkbox"}
                id={reasonsForReject.length + 1}
                checked={other}
                label={<span>{"Other"}</span>}
                value={other}
                onChange={(e) => {
                  setOther(!other);
                  setCustomReason("");
                }}
              />
            </div>
          </Form.Group>
          {other && (
            <Form.Control
              placeholder="Your Reason"
              as="textarea"
              rows={3}
              className="mt-4"
              value={customReason}
              onChange={(e) => {
                if (other) {
                  setCustomReason(e.target.value);
                }
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button as={Link} onClick={handleClose8}>
            No
          </Button>
          <Button
            as={Link}
            style={{
              color:
                selectedRejectReasons.length || customReason ? "black" : "gray",
            }}
            onClick={(e) => {
              cancel_booking_fun(e, selectedRejectReasons, customReason);
              const emptyrejectReasonsArr = rejectReasons.map((item) => {
                const newItem = item;
                newItem.checked = false;
                return newItem;
              });

              setReasonsForReject([...emptyrejectReasonsArr]);
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const handleBookAgain = async (therapist_id) => {
    setLoading(true);
    try {
      const res = await get_therapist_full_details_for_patient(therapist_id);

      if (res.status === 1) {
        setLoading(false);
        navigate("/bookanappointment", {
          state: { therapistDetails: res.data },
        });
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in handleBookAgain function", err);
    }
  };

  ///////////////////////////////////////// MAIN RETURN /////////////////////////////////////////////////

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Appointments"} />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div className="col-xl-9 col-md-8 tabBox fulltabBox dashboard_tabs">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              <Tabs
                defaultActiveKey={activeTab}
                id="uncontrolled-tab-example"
                onSelect={(tabname) => {
                  const tabLabels = { upcoming: "Upcoming", past: "Completed", requests: "Requests", cancelled: "Cancelled" };
                  trackButtonClick("dashboard_tab_switch", {
                    button_name: tabLabels[tabname] || tabname,
                    screen_name: "Dashboard",
                    user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "",
                    user_role: authUserRole,
                  });
                  fetch_lists(tabname);
                  setActiveTab(tabname);
                }}
              >
                <Tab eventKey="upcoming" title="Upcoming">
                  <div className="row mobileRow">
                    {!loadingList
                      ? isUpcomingAppointmentFetched &&
                        upcomingAppointmentList.length
                        ? upcomingAppointmentList.map((item, index) => {
                            const userDetails = IsTherapist
                              ? item.patient_details || {}
                              : item.therapist_details || {};
                            const isApproved = item.booking_approve_status;

                            return (
                              <div key={index} className="col-md- col-xl-6">
                                <div className="docListitem">
                                  <div
                                    onClick={() => {
                                      if (!IsTherapist && userDetails._id) {
                                        trackEvent("view_therapist_cta", { event_type: "item_click", screen_name: "Dashboard", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: authUserRole, therapist_name: userDetails.name });
                                        navigate(`/therapistdetailspage/${userDetails._id}`);
                                      } else {
                                        navigate(`/therapistappointmentdetail`, { state: { booking_id: item.booking_id } });
                                      }
                                    }}
                                    className="d-flex align-items-center cursor_pointer"
                                  >
                                    <UserAvatar
                                      profileImage={userDetails?.profile_img}
                                      firstName={userDetails?.first_name || userDetails?.name}
                                      lastName={userDetails?.last_name}
                                      size="md"
                                      className="imgDoc"
                                      alt={`${userDetails?.first_name} ${userDetails?.last_name}`}
                                    />
                                    <div className="l_content">
                                      <h2>
                                        <span
                                          as="button"
                                          className="uName_reverse_link_hover"
                                        >
                                          {`${userDetails?.first_name || ""} ${
                                            userDetails?.last_name || ""
                                          }`}
                                        </span>
                                        <span className="hoursCancel">
                                          {get_upcoming_timp_diff(
                                            item.created_at,
                                            item.created_at
                                          )}
                                        </span>
                                      </h2>
                                      <Tooltip
                                        id="my-tooltip-u"
                                        className="tooltip-custom-container"
                                      />
                                      {IsTherapist ? (
                                        <p className="truncated-text">
                                          {`${
                                            userDetails.gender
                                          } | ${calculateAge(
                                            userDetails.dob
                                          )} years`}
                                        </p>
                                      ) : (
                                        <p
                                          data-tooltip-id="my-tooltip-u"
                                          data-tooltip-content={item.speciality}
                                          className="truncated-text"
                                        >
                                          {item.speciality}
                                        </p>
                                      )}

                                      <div className="timeflex">
                                        <img
                                          src={CalenderIcon}
                                          className="imgDoc"
                                          alt=""
                                        />
                                        <h4>
                                          {formet_date(item.time)} |{" "}
                                          {formet_time(item.time)}
                                        </h4>
                                        <div>
                                          <img
                                            src={TimeIcon}
                                            className="imgDoc"
                                            alt=""
                                          />
                                          <span>
                                            {scheduledTimeForTherapist(
                                              item.pricing,
                                              item.pricing_id
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="btn_bottom">
                                    <Button
                                      data-tooltip-id="my-tooltip-u"
                                      data-tooltip-content={
                                        isTimeDisabled(item) && isApproved
                                          ? "You can join at your scheduled time."
                                          : ""
                                      }
                                      className="btn btn-primary btnNew "
                                      // disabled={
                                      //   isTimeDisabled(item) || !isApproved
                                      // }
                                      style={{
                                        backgroundColor:
                                          isTimeDisabled(item) || !isApproved
                                            ? "gray"
                                            : null,
                                      }}
                                      onClick={() => {
                                        !isTimeDisabled(item) &&
                                          isApproved &&
                                          userDetails._id &&
                                          navigate("/chat", {
                                            state: {
                                              chat_id: userDetails._id,
                                              data: item,
                                              navigateFrom: "upcoming",
                                            },
                                          });
                                      }}
                                    >
                                      {isApproved ? "Join" : "Pending"}
                                    </Button>
                                    {isTimeDisabled(item) && (
                                      <Link
                                        as="button"
                                        onClick={(e) => {
                                          setOpenedRequest({ ...item });
                                          fetch_booked_dates(
                                            e,
                                            item.booking_id,
                                            scheduledTimeSlotForTherapist(
                                              item.pricing,
                                              item.pricing_id
                                            ),
                                            "upcoming"
                                          );
                                        }}
                                        className="resbtn"
                                      >
                                        Reschedule
                                      </Link>
                                    )}
                                    {isTimeDisabled(item) && (
                                      <Link
                                        onClick={() => {
                                          setOpenedRequest({ ...item });
                                          // hide first popup = setModalShow3(true);
                                          show_modal_fun(setModalShow8);
                                        }}
                                        className="redbtn"
                                      >
                                        Cancel
                                      </Link>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : !loading && (
                            <div className="no_datafound calender_container">
                              <Image
                                src={NoDataFoundIcon}
                                alt="No Data Found"
                                className="img-fluid calender_img"
                              />
                              <p>NO APPOINTMENTS</p>
                              {IsTherapist ? (
                                <p className="therapist_calender_txt">
                                  Please refresh for upcoming sessions and
                                  requests.
                                </p>
                              ) : (
                                <p>Please refresh for upcoming sessions.</p>
                              )}
                            </div>
                          )
                      : !loading && (
                          // <ReactLoader
                          //   type="ping-cube"
                          //   bgColor={"#4FF2E2"}
                          //   size={30}
                          // />
                          <div className="no_datafound calender_container">
                            <ReactLoader
                              type="ping-cube"
                              bgColor={"#4FF2E2"}
                              size={50}
                            />
                          </div>
                        )}
                    {loadmoreLoading && (
                      <div className="next_loader">
                        <ReactLoader
                          type="ping-cube"
                          bgColor={"#4FF2E2"}
                          size={50}
                        />
                      </div>
                    )}
                    {/* {!loadmoreLoading &&
                      !loadingList &&
                      !isLastPage(
                        upcomingListPageNo,
                        totalUpcomingAppoiments,
                        10
                      ) && (
                        <div className="text-center mt-3">
                          <Button
                            className="btn btnNew btn-primary"
                            onClick={() => {
                              loadmore_upcoming_appointments();
                            }}
                          >
                            Next
                          </Button>
                        </div>
                      )} */}
                  </div>
                </Tab>

                <Tab eventKey="past" title="Completed">
                  <div className="row">
                    {!loadingList
                      ? isPastAppointmentFetched && pastAppointmentList.length
                        ? pastAppointmentList.map((item, index) => {
                            const userDetails = IsTherapist
                              ? item.patient_details || {}
                              : item.therapist_details || {};

                            return (
                              <div key={index} className="col-md- col-xl-6">
                                <div
                                  onClick={() => {
                                    navigate(
                                      IsTherapist
                                        ? "/therapistappointmentdetail"
                                        : `/patientappointmentdetail/${item.booking_id}`,
                                      {
                                        state: {
                                          booking_id: item.booking_id,
                                        },
                                      }
                                    );
                                  }}
                                  className="docListitem cursor_pointer"
                                >
                                  <div className="d-flex align-items-center">
                                    <UserAvatar
                                      profileImage={userDetails?.profile_img}
                                      firstName={userDetails?.first_name || userDetails?.name}
                                      lastName={userDetails?.last_name}
                                      size="md"
                                      className="imgDoc"
                                      alt={`${userDetails?.first_name} ${userDetails?.last_name}`}
                                    />
                                    <div className="l_content">
                                      <h2>
                                        <span
                                          as="button"
                                          className="uName_reverse_link_hover"
                                        >
                                          {`${userDetails?.first_name || ""} ${
                                            userDetails?.last_name || ""
                                          }`}
                                        </span>
                                        <span className="hoursCancel">
                                          {get_upcoming_timp_diff(
                                            item.created_at,
                                            item.created_at
                                          )}
                                        </span>
                                      </h2>
                                      <Tooltip
                                        id="my-tooltip-p "
                                        className="tooltip-custom-container"
                                      />
                                      {IsTherapist ? (
                                        <p className="truncated-text">
                                          {`${
                                            userDetails.gender
                                          } | ${calculateAge(
                                            userDetails.dob
                                          )} years`}
                                        </p>
                                      ) : (
                                        <p
                                          data-tooltip-id="my-tooltip-p "
                                          data-tooltip-content={item.speciality}
                                          className="truncated-text"
                                        >
                                          {item.speciality}
                                        </p>
                                      )}

                                      <div className="timeflex">
                                        <img
                                          src={CalenderIcon}
                                          className="imgDoc"
                                          alt=""
                                        />
                                        <h4>
                                          {formet_date(item.time)} |{" "}
                                          {formet_time(item.time)}
                                        </h4>
                                        <div>
                                          <img
                                            src={TimeIcon}
                                            className="imgDoc"
                                            alt=""
                                          />
                                          <span>
                                            {scheduledTimeForTherapist(
                                              item.pricing,
                                              item.pricing_id
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : !loading && (
                            <div className="no_datafound calender_container">
                              <Image
                                src={NoDataFoundIcon}
                                alt="No Data Found"
                                className="img-fluid calender_img"
                              />
                              <p>NO APPOINTMENTS</p>
                            </div>
                          )
                      : !loading && (
                          // <ReactLoader
                          //   type="ping-cube"
                          //   bgColor={"#4FF2E2"}
                          //   size={30}
                          // />
                          <div className="no_datafound calender_container">
                            <ReactLoader
                              type="ping-cube"
                              bgColor={"#4FF2E2"}
                              size={50}
                            />
                          </div>
                        )}
                    {loadmoreLoading && (
                      <div className="next_loader">
                        <ReactLoader
                          type="ping-cube"
                          bgColor={"#4FF2E2"}
                          size={50}
                        />
                      </div>
                    )}
                    {!loadmoreLoading &&
                      !loadingList &&
                      !isLastPage(
                        pastListPageNo,
                        totalPastAppointments,
                        10
                      ) && (
                        <div className="text-center mt-3">
                          <Button
                            className="btn btnNew btn-primary"
                            onClick={() => {
                              loadmore_past_appointments();
                            }}
                          >
                            Next
                          </Button>
                        </div>
                      )}
                  </div>
                </Tab>
                {IsTherapist ? (
                  <Tab eventKey="requests" title="Requests">
                    <div className="row">
                      {!loadingList
                        ? isRequestAppointmentFetched && requestList.length
                          ? requestList.map((item, index) => {
                              const patientDetails = item.patient_details || {};

                              return (
                                <div key={index} className="col-md- col-xl-6">
                                  <div className="docListitem">
                                    <div
                                      onClick={() => {
                                        navigate("/requestAppointmentDetails", {
                                          state: {
                                            booking_id: item.booking_id,
                                            patient_id: patientDetails._id,
                                          },
                                        });
                                      }}
                                      className="d-flex align-items-center cursor_pointer"
                                    >
                                      <UserAvatar
                                        profileImage={patientDetails.profile_img}
                                        firstName={patientDetails.first_name || patientDetails.name}
                                        lastName={patientDetails.last_name}
                                        size="md"
                                        className="imgDoc"
                                        alt={`${patientDetails.first_name} ${patientDetails.last_name}`}
                                      />
                                      <div className="l_content">
                                        <h2>
                                          <span
                                            as="button"
                                            className="uName_reverse_link_hover"
                                          >
                                            {`${patientDetails.first_name} ${patientDetails.last_name}`}
                                          </span>
                                          <span className="hoursCancel">
                                            {get_upcoming_timp_diff(
                                              item.created_at,
                                              item.created_at
                                            )}
                                          </span>
                                        </h2>
                                        <Tooltip
                                          id="my-tooltip-r"
                                          className="tooltip-custom-container"
                                        />
                                        <p className="truncated-text">
                                          {`${
                                            patientDetails.gender
                                          } | ${calculateAge(
                                            patientDetails.dob
                                          )} years`}
                                        </p>
                                        <div className="timeflex">
                                          <img
                                            src={CalenderIcon}
                                            className="imgDoc"
                                            alt=""
                                          />
                                          <h4>
                                            {formet_date(item.time)} |{" "}
                                            {formet_time(item.time)}
                                          </h4>
                                          <div>
                                            <img
                                              src={TimeIcon}
                                              className="imgDoc"
                                              alt=""
                                            />
                                            <span>
                                              {scheduledTimeForTherapist(
                                                item.pricing,
                                                item.pricing_id
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="btn_bottom">
                                      <Link
                                        onClick={() => {
                                          setOpenedRequest({ ...item });
                                          setModalShow5(true);
                                        }}
                                        className="btn btn-primary"
                                      >
                                        Accept
                                      </Link>
                                      <Link
                                        as="button"
                                        onClick={(e) => {
                                          setOpenedRequest({ ...item });
                                          fetch_booked_dates(
                                            e,
                                            item.booking_id,
                                            scheduledTimeSlotForTherapist(
                                              item.pricing,
                                              item.pricing_id
                                            ),
                                            "requests"
                                          );
                                        }}
                                        className="resbtn"
                                      >
                                        Reschedule
                                      </Link>
                                      <Link
                                        className="redbtn"
                                        onClick={() => {
                                          setOpenedRequest({ ...item });
                                          setModalShow7(true);
                                        }}
                                      >
                                        Reject
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : !loading && (
                              <div className="no_datafound calender_container">
                                <Image
                                  src={NoDataFoundIcon}
                                  alt="No Data Found"
                                  className="img-fluid calender_img"
                                />
                                <p>NO APPOINTMENTS</p>
                              </div>
                            )
                        : !loading && (
                            // <ReactLoader
                            //   type="ping-cube"
                            //   bgColor={"#4FF2E2"}
                            //   size={30}
                            // />
                            <div className="no_datafound calender_container">
                              <ReactLoader
                                type="ping-cube"
                                bgColor={"#4FF2E2"}
                                size={50}
                              />
                            </div>
                          )}
                      {loadmoreLoading && (
                        <div className="next_loader">
                          <ReactLoader
                            type="ping-cube"
                            bgColor={"#4FF2E2"}
                            size={50}
                          />
                        </div>
                      )}
                      {/* {!loadmoreLoading &&
                        !loadingList &&
                        !isLastPage(requestListPageNo, totalRequests, 10) && (
                          <div className="text-center mt-3">
                            <Button
                              className="btn btnNew btn-primary"
                              onClick={() => {
                                loadmore_requests();
                              }}
                            >
                              Next
                            </Button>
                          </div>
                        )} */}
                    </div>
                  </Tab>
                ) : (
                  <Tab eventKey="cancelled" title="Cancelled">
                    <div className="row">
                      {!loadingList
                        ? isCancelledAppointmentFetched &&
                          cancelledAppointmentsList.length
                          ? cancelledAppointmentsList.map((item, index) => {
                              const therapistDetails =
                                item.therapist_details || {};
                              const cancel_reasons = item.cancel_reasons || [];

                              const canceled_by_role_name =
                                item.canceled_by_role_name;

                              const get_canceledBy_text = () => {
                                if (canceled_by_role_name == "Patient") {
                                  return "You";
                                } else if (
                                  canceled_by_role_name == "Therapist"
                                ) {
                                  return "Therapist";
                                } else {
                                  return "eCare Therapy";
                                }
                              };
                              const canceled_by_text = get_canceledBy_text();

                              return (
                                <div key={index} className="col-md- col-xl-6">
                                  <div
                                    className="docListitem"
                                    style={{ position: "relative" }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (therapistDetails._id) {
                                          trackEvent("view_therapist_cta", { event_type: "item_click", screen_name: "Dashboard", user_name: user.details?.first_name ? `${user.details.first_name} ${user.details.last_name || ""}`.trim() : "", user_role: authUserRole, therapist_name: therapistDetails.name });
                                          navigate(`/therapistdetailspage/${therapistDetails._id}`);
                                        }
                                      }}
                                      className="d-flex align-items-center cursor_pointer"
                                    >
                                      <UserAvatar
                                        profileImage={therapistDetails?.profile_img}
                                        firstName={therapistDetails?.first_name || therapistDetails?.name}
                                        lastName={therapistDetails?.last_name}
                                        size="md"
                                        className="imgDoc"
                                        alt={`${therapistDetails?.first_name} ${therapistDetails?.last_name}`}
                                      />
                                      <div className="l_content">
                                        <h2>
                                          <span
                                            as="button"
                                            className="uName_reverse_link_hover"
                                          >
                                            {`${therapistDetails?.first_name} ${therapistDetails?.last_name}`}
                                          </span>
                                          <span className="hoursCancel">
                                            {get_upcoming_timp_diff(
                                              item.created_at,
                                              item.created_at
                                            )}
                                          </span>
                                        </h2>
                                        <Tooltip
                                          id="my-tooltip-r"
                                          className="tooltip-custom-container"
                                        />
                                        <p
                                          data-tooltip-id="my-tooltip-r"
                                          data-tooltip-content={item.speciality}
                                          className="truncated-text"
                                        >
                                          {item.speciality}
                                        </p>
                                        <div className="timeflex">
                                          <img
                                            src={CalenderIcon}
                                            className="imgDoc"
                                            alt=""
                                          />
                                          <h4>
                                            {formet_date(item.time)} |{" "}
                                            {formet_time(item.time)}
                                          </h4>
                                          <div>
                                            <img
                                              src={TimeIcon}
                                              className="imgDoc"
                                              alt=""
                                            />
                                            <span>
                                              {scheduledTimeForTherapist(
                                                item.pricing,
                                                item.pricing_id
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="btn_bottom">
                                      <Link
                                        onClick={() => {
                                          if (therapistDetails._id) {
                                            handleBookAgain(
                                              therapistDetails._id
                                            );
                                          }
                                        }}
                                        className="btn btn-primary  "
                                      >
                                        Book again
                                      </Link>
                                      <div>
                                        <span
                                          onClick={() => {
                                            setSelectedIndexForMore(index);
                                          }}
                                        >
                                          More
                                        </span>
                                        {selectedIndexForMore == index && (
                                          <div className="cancel_reasons">
                                            {canceled_by_text && (
                                              <>
                                                {" "}
                                                <p>Canceled By</p>
                                                <span>{canceled_by_text}</span>
                                              </>
                                            )}

                                            <p>Reason</p>
                                            {cancel_reasons.length > 0
                                              ? cancel_reasons.map((item) => (
                                                  <span>{item}.</span>
                                                ))
                                              : "Not found any reason."}
                                            <Link
                                              className="crossLink"
                                              onClick={() => {
                                                setSelectedIndexForMore(null);
                                              }}
                                            >
                                              <FaTimesCircle />
                                            </Link>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : !loading && (
                              <div className="no_datafound calender_container">
                                <Image
                                  src={NoDataFoundIcon}
                                  alt="No Data Found"
                                  className="img-fluid calender_img"
                                />
                                <p>NO APPOINTMENTS</p>
                              </div>
                            )
                        : !loading && (
                            // <ReactLoader
                            //   type="ping-cube"
                            //   bgColor={"#4FF2E2"}
                            //   size={30}
                            // />
                            <div className="no_datafound calender_container">
                              <ReactLoader
                                type="ping-cube"
                                bgColor={"#4FF2E2"}
                                size={50}
                              />
                            </div>
                          )}
                      {loadmoreLoading && (
                        <div className="next_loader">
                          <ReactLoader
                            type="ping-cube"
                            bgColor={"#4FF2E2"}
                            size={50}
                          />
                        </div>
                      )}
                      {!loadmoreLoading &&
                        !loadingList &&
                        !isLastPage(
                          cancelledListPageNo,
                          totalCancelledAppointments,
                          10
                        ) && (
                          <div className="text-center mt-3">
                            <Button
                              className="btn btnNew btn-primary"
                              onClick={() => {
                                loadmore_cancelled_appointments();
                              }}
                            >
                              Next
                            </Button>
                          </div>
                        )}
                    </div>
                  </Tab>
                )}
              </Tabs>
            </div>
          </div>
        </div>
      </section>
      {modalShow && (
        <RescheduleAppointment
          show={modalShow}
          onHide={() => {
            clearRescheduledVariables();
            setModalShow(false);
          }}
        />
      )}
      {modalShow1 && (
        <RescheduleConfirmation
          show={modalShow1}
          onHide={() => {
            setModalShow1(false);
            clearRescheduledVariables();
          }}
        />
      )}
      {modalShow2 && (
        <RescheduleConfirmed
          show={modalShow2}
          onHide={() => {
            setModalShow2(false);
            clearRescheduledVariables();
          }}
        />
      )}
      {modalShow3 && (
        <CancelAppointment
          show={modalShow3}
          onHide={() => {
            setModalShow3(false);
            setOpenedRequest({});
          }}
        />
      )}
      {modalShow4 && (
        <CancelledConfirmed
          show={modalShow4}
          onHide={() => {
            setModalShow4(false);
            setOpenedRequest({});
          }}
        />
      )}
      {modalShow5 && (
        <AcceptRequest
          show={modalShow5}
          onHide={() => {
            setModalShow5(false);

            setOpenedRequest({});
          }}
        />
      )}
      {modalShow6 && (
        <AcceptConfirmed
          show={modalShow6}
          onHide={() => {
            setModalShow6(false);
            setOpenedRequest({});
          }}
        />
      )}

      {modalShow7 && (
        <Reject_Request
          show={modalShow7}
          onHide={() => {
            setOpenedRequest({});
            setModalShow7(false);
          }}
        />
      )}
      {modalShow8 && (
        <ReasonOfCancellation
          show={modalShow8}
          onHide={() => {
            setModalShow8(false);
            setOpenedRequest({});
          }}
        />
      )}
    </>
  );
};

export default Dashboard;
